import React, { Component } from "react";
import { connect } from "react-redux";
import { v4 as uuid } from "uuid";
import {
  deleteImage,
  postImage,
  postSupplementalDocument,
  deleteSupplementalDocument,
} from "../../duck/contractImages";
import { postRenterImage, deleteRenterImage } from "../../duck/renter";
import { postCoRenterImage, deleteCoRenterImage } from "../../duck/coRenter";
import { Message, Segment, Item } from "semantic-ui-react";
import ItemUploader from "./ItemUploader";
import { Warning } from "../../components";
import "./index.scss";

const imageRefs = {
  driversLicense: {
    key_name: "drivers_license",
    response_key: "drivers_license_image",
    url: "/images/drivers-license/",
  },
  proofOfIncome: {
    key_name: "proof_of_income",
    response_key: "proof_of_income_image",
    url: "/images/proof-of-income/",
  },
  proofOfResidence: {
    key_name: "proof_of_residence",
    response_key: "proof_of_residence_image",
    url: "/images/proof-of-residence/",
  },
  // voidedCheck: {
  //   key_name: 'voided_check',
  //   response_key: 'voided_check_image',
  //   url: '/images/voided-check/',
  // },
};

class Documents extends Component {
  state = {};

  onUpload = (eventData) => {
    const imageRef = imageRefs[eventData.imageRef];

    if (!imageRef) {
      return;
    }

    const formData = new FormData();
    formData.append(imageRef.key_name, eventData.image);
    formData.append("contract_id", this.props.id);

    this.props.dispatch(
      postImage({
        imageData: formData,
        responseKey: imageRef.response_key,
        url: eventData.url,
      })
    );
  };

  onDelete = (data) => {
    this.props.dispatch(deleteImage(data));
  };

  onRenterUpload = (eventData) => {
    const imageRef = imageRefs[eventData.imageRef];
    const formData = new FormData();

    if (!imageRef) {
      return;
    }

    formData.append(imageRef.key_name, eventData.image);
    formData.append("contract_id", this.props.id);

    this.props.dispatch(
      postRenterImage({
        imageData: formData,
        responseKey: imageRef.response_key,
        stateKey: eventData.imageRef,
        url: eventData.url,
      })
    );
  };

  onRenterDelete = (data) => {
    const imageRef = imageRefs[data.imageRef];

    if (!imageRef) {
      return;
    }

    this.props.dispatch(
      deleteRenterImage({
        url: data.url,
        keyName: imageRef.response_key,
        stateKey: data.imageRef,
      })
    );
  };

  onCoRenterUpload = (eventData) => {
    const imageRef = imageRefs[eventData.imageRef];
    const formData = new FormData();

    if (!imageRef) {
      return;
    }

    formData.append(imageRef.key_name, eventData.image);
    formData.append("corenter_id", this.props.coRenter.id);

    this.props.dispatch(
      postCoRenterImage({
        imageData: formData,
        responseKey: imageRef.response_key,
        url: eventData.url,
      })
    );
  };

  onCoRenterDelete = (data) => {
    const imageRef = imageRefs[data.imageRef];

    if (!imageRef) {
      return;
    }

    this.props.dispatch(
      deleteCoRenterImage({
        url: data.url,
        keyName: imageRef.response_key,
      })
    );
  };

  onSupplementalUpload = (e) => {
    const imageRef = imageRefs[e.imageRef];
    const formData = new FormData();

    if (!imageRef) return;

    let documentId = null;

    if (e.coRenter) {
      documentId = this.props.coRenter
        ? this.props.coRenter[imageRef.response_key]
          ? this.props.coRenter[imageRef.response_key].id
          : null
        : null;
    } else {
      documentId = this.props[e.imageRef] ? this.props[e.imageRef].id : null;
    }

    if (!documentId) return;

    formData.append(`${imageRef.key_name}_image_id`, documentId);
    formData.append("supplemental_document", e.image);

    this.props.dispatch(
      postSupplementalDocument({
        imageData: formData,
        url: `/images/supplemental-document/`,
        imageKey: e.imageRef,
        coRenter: e.coRenter,
        responseKey: imageRef.response_key,
      })
    );
  };

  onSupplementalDelete = (e) => {
    if (!e.filename || !e.imageRef) return;

    this.props.dispatch(
      deleteSupplementalDocument({
        filename: e.filename,
        imageKey: e.imageRef,
        coRenter: e.coRenter,
        keyName: e.keyName,
      })
    );
  };

  render() {
    if (!this.props.id) {
      return (
        <Warning
          color="yellow"
          icon="ban"
          subheader={`This contract hasn't been created yet.`}
          header="Hold Up!"
          showButton={false}
        />
      );
    }

    if (!this.props.renter.id) {
      return (
        <Warning
          color="yellow"
          icon="ban"
          subheader="Create a renter for this contract first."
          header="Hold Up!"
          step="renter"
        />
      );
    }

    return (
      <Segment padded>
        <Item.Group divided>
          {/*
              <ItemUploader
                id="voidedCheck"
                title="Voided Check"
                onDelete={this.onDelete}
                onUpload={this.onUpload}
                url="/images/voided-check/"
                image={this.props.voidedCheck}
                imageRef="voidedCheck"
              />
            */}
          <ItemUploader
            id="renterDriversLicense"
            title={`${this.props.renterName} Driver's License`}
            onDelete={this.onRenterDelete}
            onUpload={this.onRenterUpload}
            url="/images/drivers-license/"
            imageRef="driversLicense"
            image={this.props.driversLicense}
            imageType="driversLicense"
          />
          <ItemUploader
            id="renterProofOfIncome"
            title={`${this.props.renterName} Proof of Income`}
            onDelete={this.onRenterDelete}
            onUpload={this.onRenterUpload}
            url="/images/proof-of-income/"
            imageRef="proofOfIncome"
            image={this.props.proofOfIncome}
            imageType="proofOfIncome"
            addAnother
            onSupplementalUpload={this.onSupplementalUpload}
          />
          {this.props.proofOfIncome && (
            <React.Fragment>
              {this.props.proofOfIncome.supplemental_documents.map((doc, i) => (
                <ItemUploader
                  key={uuid()}
                  id={uuid()}
                  upload={false}
                  title={`${this.props.renterName} Proof of Income #${i + 2}`}
                  onDelete={this.onSupplementalDelete}
                  imageRef="proofOfIncome"
                  url="/images/supplemental-document/"
                  image={doc}
                  addAnother
                  onSupplementalUpload={this.onSupplementalUpload}
                />
              ))}
            </React.Fragment>
          )}
          <ItemUploader
            id="renterProofOfResidence"
            title={`${this.props.renterName} Current Mortgage Statement`}
            onDelete={this.onRenterDelete}
            onUpload={this.onRenterUpload}
            url="/images/proof-of-residence/"
            imageRef="proofOfResidence"
            image={this.props.proofOfResidence}
            imageType="proofOfResidence"
            addAnother
            onSupplementalUpload={this.onSupplementalUpload}
          />
          {this.props.proofOfResidence && (
            <React.Fragment>
              {this.props.proofOfResidence.supplemental_documents.map(
                (doc, i) => (
                  <ItemUploader
                    key={uuid()}
                    id={uuid()}
                    upload={false}
                    title={`${
                      this.props.renterName
                    } Current Mortgage Statement #${i + 2}`}
                    onDelete={this.onSupplementalDelete}
                    imageRef="proofOfResidence"
                    imageType="proofOfResidence"
                    url="/images/supplemental-document/"
                    image={doc}
                    addAnother
                    onSupplementalUpload={this.onSupplementalUpload}
                  />
                )
              )}
            </React.Fragment>
          )}
          {this.props.coRenter && (
            <React.Fragment>
              <ItemUploader
                id="coRenterDriversLicense"
                title={`${this.props.coRenterName} Driver's License`}
                onDelete={this.onCoRenterDelete}
                onUpload={this.onCoRenterUpload}
                url="/images/drivers-license/"
                imageRef="driversLicense"
                image={this.props.coRenter.drivers_license_image}
                imageType="driversLicense"
              />
              <ItemUploader
                id="coRenterProofOfIncome"
                title={`${this.props.coRenterName} Proof of Income`}
                onDelete={this.onCoRenterDelete}
                onUpload={this.onCoRenterUpload}
                url="/images/proof-of-income/"
                imageRef="proofOfIncome"
                image={this.props.coRenter.proof_of_income_image}
                imageType="proofOfIncome"
                addAnother
                onSupplementalUpload={(e) =>
                  this.onSupplementalUpload({ ...e, coRenter: true })
                }
              />
              {this.props.coRenter.proof_of_income_image && (
                <React.Fragment>
                  {this.props.coRenter.proof_of_income_image.supplemental_documents.map(
                    (doc, i) => (
                      <ItemUploader
                        key={uuid()}
                        id={uuid()}
                        upload={false}
                        title={`${this.props.coRenterName} Proof of Income #${
                          i + 2
                        }`}
                        onDelete={(e) =>
                          this.onSupplementalDelete({
                            ...e,
                            coRenter: true,
                            keyName: "proof_of_income_image",
                          })
                        }
                        imageRef="proofOfIncome"
                        url="/images/supplemental-document/"
                        image={doc}
                        addAnother
                        onSupplementalUpload={(e) =>
                          this.onSupplementalUpload({ ...e, coRenter: true })
                        }
                      />
                    )
                  )}
                </React.Fragment>
              )}
              <ItemUploader
                id="coRenterProofOfResidence"
                title={`${this.props.coRenterName} Current Mortgage Statement`}
                onDelete={this.onCoRenterDelete}
                onUpload={this.onCoRenterUpload}
                url="/images/proof-of-residence/"
                imageRef="proofOfResidence"
                image={this.props.coRenter.proof_of_residence_image}
                imageType="proofOfResidence"
                addAnother
                onSupplementalUpload={(e) =>
                  this.onSupplementalUpload({ ...e, coRenter: true })
                }
              />
              {this.props.coRenter.proof_of_residence_image && (
                <React.Fragment>
                  {this.props.coRenter.proof_of_residence_image.supplemental_documents.map(
                    (doc, i) => (
                      <ItemUploader
                        key={uuid()}
                        id={uuid()}
                        upload={false}
                        title={`${
                          this.props.coRenterName
                        } Current Mortgage Statement #${i + 2}`}
                        onDelete={(e) =>
                          this.onSupplementalDelete({
                            ...e,
                            coRenter: true,
                            keyName: "proof_of_residence_image",
                          })
                        }
                        imageRef="proofOfResidence"
                        url="/images/supplemental-document/"
                        image={doc}
                        addAnother
                        onSupplementalUpload={(e) =>
                          this.onSupplementalUpload({ ...e, coRenter: true })
                        }
                      />
                    )
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </Item.Group>
      </Segment>
    );
  }
}

function mapStateToProps(state) {
  return {
    coRenter: state.coRenter,
    coRenterName: state.coRenter
      ? `${state.coRenter.first_name} ${state.coRenter.last_name}`
      : null,
    driversLicense: state.driversLicense,
    proofOfIncome: state.proofOfIncome,
    proofOfResidence: state.proofOfResidence,
    id: state.id,
    renter: state.renter,
    renterName: `${state.renter.first_name} ${state.renter.last_name}`,
    // voidedCheck: state.voidedCheck,
  };
}

export default connect(mapStateToProps)(Documents);
